import axios from "axios";
import {
    URLAPI,
    SECTIONS_PATH,
    SECTION_ITEM_PATH,
    SECTION_CREATE_PATH,
    SECTION_UPDATE_PATH,
    SINCRONIZAR_PATH,
} from "../config";
import {LOGOUT} from './users'

const init = {
    _get_all_section: {
        data: [],
        status: 0,
        message: {},
    },
    _create_section: {
        data: {},
        status: 0,
        message: {},
    },
    _update_section: {
        data: {},
        status: 0,
        message: {},
    },
    _sincronizarFormulario: {
        data: {},
        status: 0,
        message: {},
    },
}

const GET_ALL_SECTION = "GET_ALL_SECTION";
export const CREATE_SECTION = "CREATE_SECTION";
export const UPDATE_SECTION = "UPDATE_SECTION";
export const SINCRONIZAR = "SINCRONIZAR";


export const section_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_SECTION:
            return {
                ...state,
                _get_all_section: action.payload,
            };
        case CREATE_SECTION:
            return {
                ...state,
                _create_section: action.payload,
            };
        case UPDATE_SECTION:
            return {
                ...state,
                _update_section: action.payload,
            };
        case SINCRONIZAR:
            return {
                ...state,
                _sincronizarFormulario: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
}


export const get_all_section = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${SECTIONS_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_SECTION,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: GET_ALL_SECTION,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.message,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_SECTION,
                payload: {
                    data: {},
                    status: 500,
                    message: "Error al obtener los registros",
                },
            });
        }
    }
}


export const create_section = (token, data) => async (dispatch) => {
    try {

        const response = await axios.post(`${URLAPI}${SECTION_CREATE_PATH}`, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: CREATE_SECTION,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: CREATE_SECTION,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_SECTION,
                payload: {
                    data: {},
                    status: 500,
                    message: "Error al crear el registro",
                },
            });
        }
    }
}


export const update_section = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(`${URLAPI}${SECTION_UPDATE_PATH}${id}/`, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: UPDATE_SECTION,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response.data != null) {
            dispatch({
                type: UPDATE_SECTION,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_SECTION,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
}

export const sincronizarFormulario = (token, data) => async (dispatch) => {
    try {
        const response = await axios.patch(`${URLAPI}${SINCRONIZAR_PATH}`, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: SINCRONIZAR,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response.data != null) {
            dispatch({
                type: SINCRONIZAR,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: SINCRONIZAR,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
}

export const searchItemSection = async (token, id) => {
    return await axios.get(`${URLAPI}${SECTION_ITEM_PATH}${id}/`, {
        headers: {
            Authorization: `Token ${token}`,
        },
    });
}

export const clear_section = (type) => async dispatch => {
    dispatch({
        type: type,
        payload: {
            data: {},
            status: 0,
            message: {},
        },
    });
}